import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import profileImage from "../../../assets/imgs/dummy-img.png";
import "../../passenger/passenger.css";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import GoogleMapComp from "./Googlemap";
import { useLocation } from "react-router-dom";
import { Timeline } from "primereact/timeline";
import moment from "moment";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { getSocket } from "../../../services/Socket";
import { useHistory } from "react-router-dom";
import { Dialog } from "primereact/dialog"; // Import Dialog component
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Axios from "axios";
import { SOCKET_ENDPOINTS } from "../../../services/Socket";

const PassengerRide = () => {
    const [mapLoaded, setMapLoaded] = useState(false);
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [startPosition, setStartPosition] = useState(null); // Initially null to wait for user location
    const [endPosition, setEndPosition] = useState(null);
    const [directions, setDirections] = useState(null);
    const [pessangerData, setPessangerData] = useState(null);
    const [matchedPassengers, setmatchedPassengers] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [paymentGateways, setPaymentGateways] = useState([]);
    const [data, setData] = useState(null);
    const [otpDialogVisible, setOtpDialogVisible] = useState(false); // State to control OTP dialog visibility
    const inputRefs = useRef([]);

    const location = useLocation();
    const decryptedResponse = location.state?.data;
    console.log("decryptedResponse", decryptedResponse); // Debugging log to check decryptedResponse value
    const socket = getSocket();
    const history = useHistory();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.authenticationSlice?.userId);

    useEffect(() => {
        setPessangerData(decryptedResponse?.data);
        // setmatchedPassengers(decryptedResponse);
    }, [decryptedResponse]);

    console.log(startPosition, "startPosition");
    console.log(endPosition, "endPosition");

    const handleMapLoaded = useCallback(() => {
        setMapLoaded(true);
        if (startPosition) fetchDirections();
    });
    const fetchDirections = () => {
        if (!startPosition) return;
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: startPosition,
                destination: endPosition,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                    console.log("Directions fetched successfully:", result);
                } else {
                    console.error("Error fetching directions:", status);
                }
            }
        );
    };

    useEffect(() => {
        if (decryptedResponse) {
            console.log(decryptedResponse?.data?.route, "decryptedResponse");
            const { startPoint, endPoint } = decryptedResponse?.data?.route;

            // Check and set start position if valid
            if (startPoint?.latitude && startPoint?.longitude) {
                setStartPosition({
                    lat: startPoint.latitude,
                    lng: startPoint.longitude,
                });
            } else {
                console.warn("Start point is null or incomplete");
            }

            // Check and set end position if valid
            if (endPoint?.latitude && endPoint?.longitude) {
                setEndPosition({
                    lat: endPoint.latitude,
                    lng: endPoint.longitude,
                });
            } else {
                console.warn("End point is null or incomplete");
            }
        } else {
            console.warn("matchedPassengers.data is null or undefined");
        }
    }, [pessangerData?.data]);

    useEffect(() => {
        // Emit an event to request live location updates

        // Listen for the "refreshLiveLocation" event
        socket.on(SOCKET_ENDPOINTS.REFRESH_LIVE_LOCATION, (data) => {
            console.log(data, "data");
            const decryptedData = handleDecryptData(data?.cipher); // Decrypt the received data
            console.log("Live Location Update:", decryptedData);

            if (decryptedData?.location) {
                setStartPosition({
                    lat: decryptedData.location.latitude,
                    lng: decryptedData.location.longitude,
                });
            }
        });

        // Cleanup on component unmount
    }, []);

    useEffect(() => {
        const fetchWalletInfo = async () => {
            try {
                const response = await dispatch(handlePostRequest("api/user/getWalletInfo", { userId }, true, true));
                if (response?.data) {
                    setData(response.data);
                } else {
                    console.warn("Response missing data:", response);
                }
            } catch (error) {
                console.error("Error fetching wallet info:", error);
            }
        };

        if (userId) {
            fetchWalletInfo();
        } else {
            console.warn("User ID is undefined");
        }
    }, [dispatch, userId]);

    useEffect(() => {
        socket.on("error", (error) => {
            try {
                console.log("Socket Error:", error);
                const decryptedError = handleDecryptData(error);
                const errorMessage = decryptedError?.message || "Unknown error";
                toast.error(`Socket Error: ${errorMessage}`);
                console.log(decryptedError, "error");
            } catch (e) {
                toast.error("Failed to decrypt error message");
                console.error("Decryption error:", e);
            }
        });

        return () => {
            socket.off("error");
        };
    }, [socket]);

    useEffect(() => {
        if (socket) {
            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                console.log("Matched refreshDriverRoutes Listener:", response);
            });

            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                console.log("Matched passengerRideCancellationListener Listener:", response);
            });
        }
    }, [socket]);

    const handleConvert = () => {
        setPaymentGateways([{ name: "Zindigi" }, { name: "Payfast" }]);
        setIsModalVisible(true);
    };

    const handleZindigiClick = () => {
        if (data?.data?.walletInfo?.zindigiWallet?.linked === false) {
            history.push("/wallet-zindigi-login");
        } else if (data?.data?.walletInfo?.zindigiWallet?.linked === true) {
            // Send Complete Ride OTP
            const scheduleId = decryptedResponse?.data?.data?.schedule?._id; // Use scheduleId instead of passengerId
            // const encryptedData = handleEncryptData({ scheduleId });
            const encryptedData = {
                passengerId: userId,
            };
            const encryptData = handleEncryptData(encryptedData);
            socket.emit("sendCompleteRideOTP", JSON.stringify(encryptData), (response) => {
                const decryptedResponse = handleDecryptData(response?.cipher);
                if (decryptedResponse?.status === true) {
                    setOtpDialogVisible(true); // Show OTP dialog
                    setIsModalVisible(false); // Close the modal
                } else {
                    toast.error("Failed to send OTP");
                }
            });
        }
    };

    const payFastBaseUrl = "https://ipguat.apps.net.pk/"; // UAT
    const _getTokenUrl = `${payFastBaseUrl}Ecommerce/api/Transaction/GetAccessToken`;
    console.log("payFastBaseUrl", payFastBaseUrl);
    console.log("_getTokenUrl", _getTokenUrl);
    const handlePayfastClick = async () => {
        const fare = decryptedResponse?.data?.schedule?.fare;
        console.log(fare, "fare on passenger ride");
        history.push({
            pathname: "/payfast",
            state: { data: decryptedResponse },
        });
    };

    const otpValidationSchema = Yup.object({
        OTP: Yup.array()
            .of(Yup.string().matches(/^[0-9]?$/, "Each field must be a single digit."))
            .test("all-filled", "All fields must be filled and valid.", (values) => values.every((value) => /^[0-9]$/.test(value))),
    });

    const otpFormik = useFormik({
        validationSchema: otpValidationSchema,
        initialValues: { OTP: ["", "", "", "", ""] },
        onSubmit: async ({ OTP }) => {
            const otpPin = OTP.join("");
            const payload = {
                userId,
                mobileNo: data?.data?.walletInfo?.mobileNo,
                dateTime: new Date().toISOString(),
                cnic: data?.data?.walletInfo?.cnic,
                otpPin: otpPin,
            };
            try {
                const response = await dispatch(handlePostRequest("api/zindigi/linkAccount", payload, true, true));
                if (response?.status === 200) {
                    history.push("/passenger-profile");
                } else {
                    toast.error("Failed to verify OTP");
                }
            } catch (error) {
                console.error("Error verifying OTP:", error);
                toast.error("Error verifying OTP");
            }
        },
    });

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^[0-9]$/.test(value) && value !== "") return;

        const otp = [...otpFormik.values.OTP];
        otp[index] = value;
        otpFormik.setFieldValue("OTP", otp);
        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        const { key } = e;
        if (key === "ArrowLeft" && index > 0) {
            inputRefs?.current[index - 1]?.focus();
        } else if (key === "ArrowRight" && index < inputRefs?.current?.length - 1) {
            inputRefs?.current[index + 1]?.focus();
        } else if (key === "Backspace") {
            const otp = [...otpFormik.values.OTP];
            if (otp[index] === "" && index > 0) {
                inputRefs?.current[index - 1]?.focus();
            } else {
                otp[index] = "";
                otpFormik.setFieldValue("OTP", otp);
            }
        }
    };

    const getOtpFormErrorMessage = () => otpFormik.errors.OTP && otpFormik.touched.OTP && <small className="p-error">{otpFormik.errors.OTP}</small>;

    const userMarkers = matchedPassengers?.matchedPassengers?.map((passenger) => ({
        position: {
            lat: passenger?.startPoint?.latitude,
            lng: passenger?.startPoint?.longitude,
        },
        title: passenger?.userId?.firstName || "Unknown User",
        icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", // Optional: Customize the icon for each user
    }));

    /////////////////////  Sockets  /////////////////////

    const onTheWay = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: matchedPassengers?.data?._id,
            passengerId: passengerId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptedData, "encryptedData");
        // Emit the socket event
        socket.emit("onTheWay", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
        });
    };

    const handleCancelRoute = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: matchedPassengers?.data?._id,
            passengerId: passengerId,
            reason: "reason",
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        // socket.emit("cancelInRidePassengerRequestByDriver", JSON.stringify(encryptData), (response) => {
        //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
        //     console.log(decryptedResponse, "decryptedResponse Start");
        // });
    };

    const handlearrived = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: matchedPassengers?.data?._id,
            passengerId: passengerId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        // socket.emit("arrived", JSON.stringify(encryptedData), (response) => {
        //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
        //     console.log(decryptedResponse, "decryptedResponse Start");
        // });
    };

    const handleStartRoute = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: matchedPassengers?.data?._id,
            passengerId: passengerId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptedData, "encryptedData");
        // Emit the socket event
        // socket.emit("startRide", JSON.stringify(encryptedData), (response) => {
        //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
        //     console.log(decryptedResponse, "decryptedResponse Start");
        // });
    };

    const handleCompleteRoute = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: matchedPassengers?.data?._id,
            passengerId: passengerId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptedData, "encryptedData");
        // Emit the socket event
        // socket.emit("pendingPayment", JSON.stringify(encryptedData), (response) => {
        //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
        //     console.log(decryptedResponse, "decryptedResponse Start");
        // });
    };

    return (
        <>
            <div style={{ margin: "0 auto", maxWidth: "80vw", height: "70vh" }}>
                <GoogleMapComp
                    directions={directions}
                    mapLoading={handleMapLoaded}
                    startPosition={startPosition}
                    endPosition={endPosition}
                    userMarkers={userMarkers} // Pass user markers array
                />
            </div>
            <div>
                {pessangerData?.route ? (
                    <div className="surface-card p-4 md:m-2">
                        <div className="flex align-items-center justify-content-between ">
                            <div className="flex align-items-center cursor-pointer">
                                <Avatar className="profile-image border-circle cursor-pointer mr-3" image={profileImage} size="xlarge" shape="circle" />
                                <div>
                                    <p className="mb-1 text-lg font-semibold">{pessangerData?.route?.userId?.firstName}</p>
                                    {/* <Rating value={pessangerData.route.rating} readOnly cancel={false} /> */}
                                </div>
                            </div>
                            <div className="cursor-pointer" style={{ display: "flex", gap: "10px" }}>
                                {/* <i
                                    className="pi pi-comments "
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        textAlign: "center",
                                        paddingTop: "10px",
                                        borderRadius: "50px",
                                        background: "#f2882c",
                                        fontSize: "2rem",
                                    }}
                                ></i>
                                <i
                                    className="pi pi-phone "
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50px",
                                        paddingTop: "10px",
                                        paddingLeft: "10px",
                                        background: "blue",
                                        fontSize: "2rem",
                                    }}
                                ></i> */}
                            </div>
                        </div>
                        <hr />
                        <div className="flex align-items-center justify-content-between flex-wrap ml-2">
                            <h6 className="my-1">Date & Time</h6>
                            <span className="font-semibold">{moment(pessangerData?.route?.endTime).format("Do MMM, YYYY hh:mm A")}</span>
                        </div>
                        <div className="flex flex-row justify-content-between mt-1">
                            <Timeline
                                value={[
                                    {
                                        status: pessangerData?.route?.startPoint?.placeName || "Not found",
                                        icon: "pi pi-map-marker",
                                    },
                                    {
                                        status: pessangerData?.route?.endPoint?.placeName || "Not found",
                                        icon: "pi pi-flag",
                                    },
                                ]}
                                align="left"
                                className="custom-timeline"
                                marker={(item) => (
                                    <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                        <i className={item?.icon} style={{ fontSize: "1.5rem" }}></i>
                                    </span>
                                )}
                                content={(item) => (
                                    <div className="flex flex-column">
                                        <span>{item?.status}</span>
                                    </div>
                                )}
                            />
                        </div>
                        <div className="grid lg:justify-content-between">
                            <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                <p className="mb-1">Distance</p>
                                <h6 className="my-0 font-semibold">{pessangerData?.route?.distance}</h6>
                            </div>
                            <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                <p className="mb-1">Fare</p>
                                <h6 className="my-0 font-semibold">{pessangerData?.schedule?.fare}</h6>
                            </div>
                            <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                <p className="mb-1">Seats</p>
                                <h6 className="my-0 font-semibold">{pessangerData?.schedule?.seats}</h6>
                            </div>
                        </div>
                        {decryptedResponse?.data?.status === "started" ? (
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    label="Cancel"
                                    type="button"
                                    onClick={() => {
                                        handleCancelRoute(pessangerData?.route?._id);
                                    }}
                                    className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                                />
                                <Button
                                    label="On the way"
                                    onClick={() => {
                                        onTheWay(pessangerData?.route?._id);
                                    }}
                                    type="button"
                                    className="block font-medium m-2 text-lg w-9rem"
                                />
                            </div>
                        ) : null}
                        {decryptedResponse?.status === "pendingPayment" ? (
                            <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                                {" "}
                                <Button label="Pay" type="button" onClick={handleConvert} className="p-button p-button-danger block font-medium m-2 text-lg w-9rem" />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ) : (
                    <p>No driver data available</p>
                )}
            </div>

            <Dialog header="Payment Gateways" visible={isModalVisible} style={{ width: "50vw" }} onHide={() => setIsModalVisible(false)}>
                <div>
                    {paymentGateways.length > 0 ? (
                        paymentGateways.map((gateway, index) => <Button key={index} label={gateway.name} className="w-full mt-2" onClick={gateway.name === "Zindigi" ? handleZindigiClick : gateway.name === "Payfast" ? handlePayfastClick : null} />)
                    ) : (
                        <p>No payment gateways available.</p>
                    )}
                </div>
            </Dialog>

            <Dialog header="OTP Verification" visible={otpDialogVisible} style={{ width: "30vw", background: "blue" }} onHide={() => setOtpDialogVisible(false)}>
                <div className="otp-verification-container flex justify-content-center align-items-center flex-column mt-5">
                    <h2 className="otp-heading mb-3">OTP Verification</h2>
                    <p className="otp-message text-center mb-3">We have sent an OTP to your mobile number</p>
                    <label htmlFor="otp" className="mb-2">
                        Enter the 5-digit SMS OTP
                    </label>
                    <form className="flex flex-column justify-content-center" onSubmit={otpFormik.handleSubmit}>
                        <div className="flex justify-content-center mb-3">
                            {otpFormik.values.OTP.map((value, index) => (
                                <InputText
                                    key={index}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    value={value}
                                    onChange={(e) => handleChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    maxLength={1}
                                    className={`otp-input mr-2 ${otpFormik.errors.OTP && otpFormik.touched.OTP ? "p-invalid" : ""}`}
                                    style={{ width: "40px", textAlign: "center" }}
                                />
                            ))}
                        </div>
                        {getOtpFormErrorMessage()}
                        <Button type="submit" label="Verify" className="p-button-primary mt-3" />
                    </form>
                </div>
            </Dialog>
        </>
    );
};

export default PassengerRide;
